import React from "react";
import {observer} from "mobx-react";
import {useViewController} from "data/services/locator";
import {Bindings} from "data/constants/bindings";
import {type IEndSeasonController} from "views/components/route/end_season/end_season.controller";
import {Outlet} from "react-router-dom";
import {IS_SEASON_END} from "data/constants";
import styled from "@emotion/styled";
import {HocLayout} from "views/components/hoc_layout/hoc_layout.component";
import {Box, Stack, Typography} from "@mui/material";
import {ReactComponent as NflLogo} from "assets/img/icons/modal/modalLogo.svg";

const Wrapper = styled.div`
	display: flex;
	flex: 1;
	justify-content: center;
	align-items: center;
	padding: 0 20px;
`;

const Container = styled.div`
	width: 100%;
	max-width: 486px;
	padding: 150px 20px 20px 20px;
	flex-direction: column;
	align-items: center;
	gap: 16px;
	background: #fff;
	border-radius: 8px;
	margin: 90px auto 60px;
	color: #000;
	position: relative;

	h2 {
		color: var(--secondaryColor);
		text-align: center;
		font-family: var(--fontFamilyBase);
		font-size: 40px;
		font-style: normal;
		font-weight: 900;
		line-height: 34px; /* 85% */
		text-transform: capitalize;
	}

	h5 {
		color: #151515;
		text-align: center;
		font-family: var(--fontFamilyBase);
		font-size: 16px;
		font-style: normal;
		font-weight: 600;
		line-height: 140%; /* 22.4px */
	}
`;
const LogoContainer = styled(Box)`
	position: absolute;
	top: -110px;
	left: 50%;
	transform: translateX(-50%);
	width: 300px;

	svg {
		width: 100%;
		height: auto;
	}
`;
export const EndSeason: React.FC = observer(() => {
	const {i18n, isSecretPassed, setCount} = useViewController<IEndSeasonController>(
		Bindings.EndSeasonController
	);

	if (!isSecretPassed && IS_SEASON_END) {
		return (
			<HocLayout withBg={true} className="full-screen">
				<Wrapper>
					<Container>
						<LogoContainer onClick={setCount}>
							<NflLogo width="128px" height="128px" />
						</LogoContainer>
						<Stack direction="column" gap={3}>
							<Typography textAlign="center" variant="h5">
								{i18n.t(
									"page.end_season.description",
									"Thanks for playing Super Bowl Challenge! Come back next season to play again."
								)}
							</Typography>
						</Stack>
					</Container>
				</Wrapper>
			</HocLayout>
		);
	}

	return <Outlet />;
});
